import { useState } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../utils/apiHelpers';

export const useApiOperations = (endpoint) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiGet(endpoint);
      return response.data;
    } catch (err) {
      setError(`Failed to fetch data: ${err.message}`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createItem = async (data) => {
    setLoading(true);
    setError('');
    try {
      await apiPost(endpoint, data);
    } catch (err) {
      setError(`Failed to create item: ${err.message}`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateItem = async (id, data) => {
    setLoading(true);
    setError('');
    try {
      await apiPut(`${endpoint}/${id}`, data);
    } catch (err) {
      setError(`Failed to update item: ${err.message}`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (id) => {
    setLoading(true);
    setError('');
    try {
      await apiDelete(`${endpoint}/${id}`);
    } catch (err) {
      setError(`Failed to delete item: ${err.message}`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    fetchData,
    createItem,
    updateItem,
    deleteItem
  };
};